var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "受检单位信息",
        okText: "确认",
        cancelText: "取消",
        width: "1000px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "受检单位名称",
                        prop: "name",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "name", $$v)
                          },
                          expression: "formState.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "受检单位代码", prop: "code" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "code", $$v)
                          },
                          expression: "formState.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "法人或负责人姓名", prop: "bossName" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.bossName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "bossName", $$v)
                          },
                          expression: "formState.bossName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "邮编", prop: "mailCode" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.mailCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "mailCode", $$v)
                          },
                          expression: "formState.mailCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "联系人", prop: "connectName" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.connectName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "connectName", $$v)
                          },
                          expression: "formState.connectName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "联系电话", prop: "tel" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.tel,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "tel", $$v)
                          },
                          expression: "formState.tel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "传真", prop: "fax" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.fax,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "fax", $$v)
                          },
                          expression: "formState.fax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "主管单位", prop: "leaderOrg" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.leaderOrg,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "leaderOrg", $$v)
                          },
                          expression: "formState.leaderOrg",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "所属区域", prop: "district" } },
                    [
                      _c("a-ext-dist-picker-qu", {
                        model: {
                          value: _vm.formState.district,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "district", $$v)
                          },
                          expression: "formState.district",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "所属乡镇/街道", prop: "town" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.town,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "town", $$v)
                          },
                          expression: "formState.town",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "监测环节", prop: "checkType" } },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "MonitLink" },
                        model: {
                          value: _vm.formState.checkType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "checkType", $$v)
                          },
                          expression: "formState.checkType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "受检单位性质", prop: "orgType" } },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "DanWeiXingZhi" },
                        model: {
                          value: _vm.formState.orgType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "orgType", $$v)
                          },
                          expression: "formState.orgType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "规模类型", prop: "lotType" } },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "GuiMoLeiXing" },
                        model: {
                          value: _vm.formState.lotType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "lotType", $$v)
                          },
                          expression: "formState.lotType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "规模单位", prop: "lotUnit" } },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "Unit" },
                        model: {
                          value: _vm.formState.lotUnit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "lotUnit", $$v)
                          },
                          expression: "formState.lotUnit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "企业规模", prop: "orgLot" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.orgLot,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "orgLot", $$v)
                          },
                          expression: "formState.orgLot",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "经度", prop: "lng" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.lng,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "lng", $$v)
                          },
                          expression: "formState.lng",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "纬度", prop: "lat" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.lat,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "lat", $$v)
                          },
                          expression: "formState.lat",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "详细地址",
                        prop: "address",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "address", $$v)
                          },
                          expression: "formState.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }